"use client";

import useEmblaCarousel from "embla-carousel-react";
import { useCallback, useEffect, useState } from "react";
import type { HeroCardStoryblok } from "~/generated/sb/blok-types";

export const useHeroSlider = ({ images }: { images?: HeroCardStoryblok[] }) => {
	const [selectedIndex, setSelectedIndex] = useState(0);
	const [scrollSnaps, setScrollSnaps] = useState<number[]>([]);
	const [emblaRef, emblaApi] = useEmblaCarousel({
		inViewThreshold: 1,
		skipSnaps: true,
		axis: "x",
		align: "start",
		draggable: (images?.length || 0) > 1,
		loop: false,
		speed: 10,
	});

	const onSelect = useCallback(() => {
		if (emblaApi && images) {
			setScrollSnaps(emblaApi.scrollSnapList());
			setSelectedIndex(emblaApi.selectedScrollSnap());
		}
	}, [emblaApi, images]);

	useEffect(() => {
		if (!emblaApi) return;
		if (!images) return;
		emblaApi.on("reInit", onSelect);
		emblaApi.on("select", onSelect);
	}, [emblaApi, images, onSelect]);

	useEffect(() => {
		if (!emblaApi) return;
		emblaApi.reInit();
		emblaApi.scrollTo(0);
	}, [emblaApi]);

	const scrollTo = (index: number) => {
		if (emblaApi) {
			emblaApi.scrollTo(index);
		}
	};

	return {
		emblaRef,
		emblaApi,
		scrollTo,
		scrollSnaps,
		selectedIndex,
	};
};
